import React from 'react';

export const DISCOUNT_DISPLAY_MODES = {
  SUMMARY_ONLY: 'summary_only',
  SUBTOTAL_STRIKE: 'subtotal_strike',
  COLUMN: 'column',
} as const;

export type DiscountDisplayMode =
  (typeof DISCOUNT_DISPLAY_MODES)[keyof typeof DISCOUNT_DISPLAY_MODES];

export const DISCOUNT_DISPLAY_DEFAULT: DiscountDisplayMode =
  DISCOUNT_DISPLAY_MODES.COLUMN;

export interface DiscountDisplayOption {
  value: DiscountDisplayMode;
  label: string;
  description: React.ReactNode;
}

export const DISCOUNT_DISPLAY_OPTIONS: DiscountDisplayOption[] = [
  {
    value: DISCOUNT_DISPLAY_MODES.SUMMARY_ONLY,
    label: 'Hide discounts',
    description:
      'On customer facing areas, display discounts only in Inventory Discount Table and Billing Summary',
  },
  {
    value: DISCOUNT_DISPLAY_MODES.SUBTOTAL_STRIKE,
    label: 'Strikethrough on Subtotal',
    description: (
      <span>
        Display Discounts via Strikethrough on Subtotals{' '}
        (<span className='strikeThrough'>$20.00</span> $18.00).
      </span>
    ),
  },
  {
    value: DISCOUNT_DISPLAY_MODES.COLUMN,
    label: 'Discounts Column',
    description:
      'Show Discounts on their own column, reflecting in the subtotals',
  },
];
